module.exports = __webpack_public_path__ + "images/emails/wildbit-dce1dbfc.png";